export default "__VITE_PUBLIC_ASSET__356db92c__"